import * as runtime from '@/api/runtime'
import {
  BatchStatisticsPageLoadRequest,
  BatchStatisticsPageLoadRequestToJSON
} from '@/api'
import {
  BatchNrcMarcCatalogRegPageLoadResult,
  BatchNrcMarcCatalogRegPageLoadResultFromJSON
} from '@/api/models/batch/BatchNrcMarcCatalogRegPageLoadResult'
import {
  BatchNrcMarcCatalogRegRequest,
  BatchNrcMarcCatalogRegRequestToJSON
} from '@/api/models/batch/BatchNrcMarcCatalogRegRequest'

export class BatchNrcMarcCatalogRegApi extends runtime.BaseAPI {
  /**
   * 画面初期表示時の検索状態取得
   * @param request
   */
  async readInitialPattern(
    request: BatchStatisticsPageLoadRequest
  ): Promise<BatchNrcMarcCatalogRegPageLoadResult> {
    const response = await this.requestGet(
      `/batch/statistics/search_initial_condition`,
      BatchStatisticsPageLoadRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      BatchNrcMarcCatalogRegPageLoadResultFromJSON(jsonValue)
    ).value()
  }

  async createNrcMarcCatalogRegist(
    request: BatchNrcMarcCatalogRegRequest
  ): Promise<number> {
    const response = await this.requestPost(
      `/batch/bibliography/regist-nrc-marc-catalog`,
      BatchNrcMarcCatalogRegRequestToJSON(request)
    )

    return new runtime.JSONApiResponse(response, jsonValue =>
      Number(jsonValue.request_id)
    ).value()
  }
}
